import getApi from "../api/getApi";
import putApi from "../api/putApi";
import * as url from "../api/url";

export const getUserMetadata = (header, instance, accounts) =>
  new Promise((resolve, reject) =>
    getApi
      .get(url.VIZY_USER_METADATA, header, instance, accounts)
      .then((response) => resolve(response))
      .catch((err) => reject(err.response))
  );

export const updateUserMetadata = (payload, header, instance, accounts) =>
  new Promise((resolve, reject) =>
    putApi
      .put(url.VIZY_USER_METADATA, payload, header, instance, accounts)
      .then((response) => resolve(response))
      .catch((err) => reject(err.response))
  );
